export default __webpack_public_path__ + "static/media/consorcioLogo.b81a0562.svg";